module.exports = __webpack_public_path__ + "static/media/sportShootingImg1_.b4dc7093.jpg";